"use client";

import { siteConfig } from "@/lib/siteConfig";

import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { AnimatedNumber } from "@/components/motion-primitives/animated-number";
import { useRef, useState } from "react";
import * as Lucide from "lucide-react";
import { useInView } from "framer-motion";
import { TextRoll } from "@/components/motion-primitives/text-roll";
import Image from "next/image";
import Link from "next/link";

export default function HeroComponent() {
  const [stats, setStats] = useState([
    { number: 0, label: "Years Experience", Icon: Lucide.Building2 },
    { number: 0, label: "Industry Sectors", Icon: Lucide.Target },
    { number: 0, label: "Trusted Clients", Icon: Lucide.Users },
    { number: 0, label: "Global Locations", Icon: Lucide.Globe },
  ]);

  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref);

  if (isInView && stats.every((stat) => stat.number === 0)) {
    setStats(siteConfig.getStats);
  }

  return (
    <section
      className={`min-h-fit wrapper hero py-10`}
      style={{
        maskImage:
          "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)", // Added mask for fading edges
        WebkitMaskImage:
          "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)", // Added for Safari compatibility
      }}
    >
      <div className="mx-auto flex items-center flex-col gap-4 lg:gap-8 text-center">
        <Image
          src={"/new_logo.png"}
          alt={"logo"}
          width={350}
          height={250}
          className={"rounded dark:bg-white square-gradient-bg"}
        />
        <TextRoll className="text-xl font-semibold text-muted-foreground">
          Innovating Bhutan with Technology
        </TextRoll>
        <span className={"flex gap-4 text-lg font-semibold"}>
          <Link href={"/features#industry-solutions"}>
            <Button>
              Explore Our Services <ChevronRight />
            </Button>
          </Link>
          <Link href={"/faq#contact"}>
            <Button variant={"outline"}>Contact Us</Button>
          </Link>
        </span>
        <div ref={ref} className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <span
              key={stat.label}
              className={"flex flex-col items-center gap-4"}
            >
              <div className={"bg-primary/10 rounded p-8"}>
                <stat.Icon className={"size-8 text-primary "} />
              </div>
              {/*<h3 className={"text-4xl font-extrabold"}>{stat.number}</h3>*/}
              <AnimatedNumber
                className="inline-flex items-center text-4xl font-extrabold"
                springOptions={{
                  bounce: 0,
                  duration: 5000,
                }}
                value={Number(stat.number)}
              />
              <p className={"text-sm font-semibold text-muted-foreground"}>
                {stat.label}
              </p>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
